<template>
	<!-- <div style="background: #f9f9f9" :style="{ height: parkHeight }"> -->
	<div style="background: #f9f9f9" :style="{ height: parkHeight }">
		<div class="tittle flex">
			<div class="titleTop">
				<div class="logo">
					<img src="../../assets/logo.png" alt="" @click="getRegisteredLogin(1)" />
				</div>
				<!-- <div class="login flex"> -->
				<div class="login flex">
					<div class="lh90" @click="getRegisteredLogin(1)">首页</div>
					<!-- <div class="lh90" @click="getRegisteredLogin(2)">帮助中心</div> -->
					<div class="lh90" @click="getRegisteredLogin(2)">文档</div>
				</div>
			</div>
		</div>

		<div style="height: 86px"></div>
		<div class="registered">
			<div class="registeredTop flex">
				<h3>账号注册</h3>
				<p>
					已有账号，
					<span class="blue" @click="getLogin">请登录 > </span>
				</p>
			</div>
			<div class="registered_input_box">
				<div class="registered_input">
					<div class="passAg">
						<el-input placeholder="输入昵称" v-model="inputUsername" clearable>
						</el-input>
						<p class="red"></p>
					</div>

					<div class="passAg">
						<el-input placeholder="输入手机号码" v-model="inputIphone" clearable @blur="getinputIphone">
						</el-input>
						<p class="red">{{ iphoneRepeatMess }}</p>
					</div>
					<div class="passAg">
						<el-input placeholder="请设置您的密码" show-password v-model="inputPassword"
							@keyup.native="cryptographic">
						</el-input>
						<p class="red">{{cryptographicMessage}}</p>
					</div>

					<div class="passAg" style="margin-bottom: 20px">
						<el-input placeholder="再次输入密码" show-password v-model="inputPasswordAg"
							@change="passwordAgChange">
						</el-input>
						<p v-if="passwordAgTrue" class="red">您输入的密码与第一次不符</p>
					</div>

					<div class="registered_validation flex" @click="getValidation" v-show="vcodes == false">
						<img src="../../assets/validation.png" alt="" />

						<p>点击按钮开始安全验证</p>
						<Vcode :show="validation" @success="onValidation('yes')" @fall="onValidation('no')"
							@close="onClose" :imgs="imgUrls" />
					</div>
					<div class="registered_validation2 flex" v-show="vcodes == true">
						<i class="el-icon-check"></i>
						<p>验证成功</p>
					</div>

					<div class="registered_input_message">
						<el-input placeholder="短信验证码" v-model="inputMessage"></el-input>
						<p class="registered_input_messageP blue" @click="getCountdown" v-if="canClick">
							获取验证码
						</p>
						<p class="registered_input_messageP" v-else style="color: #b5b5b5">
							{{ timeClock }}s
						</p>
					</div>
					<div class="registered_message">
						增材云账号服务需要联网，并获取您的账号、大致位置信息、应用信息以及您主动上传的个人基本资料、身份信息。
						点击"注册"，即表示您同意上述内容及<span class="blue" @click="getAgreement">增材云用户隐私协议
						</span>
					</div>
					<div class="registered_agree">
						<el-checkbox v-model="checked" class="blue">
							我已阅读并同意
							<span class="red" @click="getAgreement">《隐私协议》</span>
						</el-checkbox>
					</div>
					<el-dialog title="增材云用户隐私协议" :visible.sync="dialogVisible" width="900px" center>
						<div>
							<!--<p>增材云平台服务协议</p>-->
							<p style="text-indent: 30px">
								为保障增材云平台用户合法权益，维护增材云平台正常经营秩序，根据国家相关法律法规制定《增材云平台服务协议》（以下简称《平台协议》或本协议），本协议具有合同效力。用户注册时，请您认真阅读本协议，审阅并接受或不接受本协议（未成年人应在法定监护人陪同下审阅）。
							</p>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第一条 接受协议</p>
							<p style="text-indent: 30px">
								本协议内容包括协议正文及所有增材云平台已经发布或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。
								您在点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您对协议有任何疑问，可致电（4000666595）向增材云平台客服咨询。
								当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序，或以任何方式进入增材云平台并使用服务即表示您已充分阅读、理解并同意接受本协议的条款和条件。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序并停止使用服务。
								本平台有权随时变更本协议并在本平台上予以公告。经修订的条款一经在本平台的公布后，立即自动生效。如果您拒绝接受新的协议，您必须放弃使用增材云平台提供的服务；若您继续使用增材云平台提供的服务，则表明您已阅读、理解、认可并接受新的协议。
								用户在增材云平台进行企业认证时，应当认真阅读并同意接受本规则约束，不同意接受本规则的，不能进行认证和使用增材云平台的各项服务；同理，用户使用平台服务即视同接受本规则。</p>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第二条 用户资格</p>
							<p style="text-indent: 30px">只有符合下列条件之一的自然人或法人才能申请成为增材云平台用户，可以使用增材云平台的服务。</p>
							<dl style="padding-left: 30px;">
								<dd style="padding-left:30px;position: relative;"><span
										style="position: absolute;left: 0;">(一)</span> 年满十八岁，并具有民事权利能力和民事行为能力的自然人；
								</dd>
								<dd style="padding-left:30px;position: relative;"><span
										style="position: absolute;left: 0;">(二)</span> 无民事行为能力人或限制民事行为能力人应经过其监护人的同意；
								</dd>
								<dd style="padding-left:30px;position: relative;"><span
										style="position: absolute;left: 0;">(三)</span>
									根据中国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。无法人资格的单位或组织不当注册为增材云平台用户的，其与增材云平台之间的协议自始无效，增材云平台一经发现，有权立即注销该用户，并追究其使用增材云平台服务的一切法律责任。
								</dd>
							</dl>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第三条、用户信息管理</p>
							<ol style="padding-left: 65px;">
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户须同时凭用户名和密码登录服务，对于通过其他手段登录、使用所造成的后果，服务提供方将不承担任何责任。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									服务提供方仅根据用户名和密码确认使用服务的用户身份。用户应妥善保管用户名和密码，并对其使用及其遗失自行承担责任。用户承诺，如其用户名和密码遭到未获授权的使用，或者发生其他任何安全问题时，将立即通知服务提供方。用户在此同意并确认，服务提供方对因上述情形产生的遗失或损害不负责任。
								</li>
							</ol>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第四条 用户的权利和义务</p>
							<ol style="padding-left: 65px;">
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户有权根据本协议及增材云平台发布的相关规则，利用增材云平台发布需求信息、产品信息、查询用户信息、购买商品，参加增材云平台的有关活动及有权享受增材云平台提供的其他有关资讯及信息服务。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户应当向本平台提供真实准确的注册信息，包括但不限于真实姓名、身份证号、联系电话、地址、邮政编码等，平台将充分保护用户的隐私权。保证本平台可以通过上述联系方式与自己进行联系。在交易的过程中可以使用昵称，同时，用户也应当在相关资料实际变更时及时更新有关注册资料。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户在本平台注册的账号名称，不得有下列情形：
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span> 违反宪法或法律法规规定的；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(三)</span> 损害国家荣誉和利益的，损害公共利益的；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(四)</span> 煽动民族仇恨、民族歧视，破坏民族团结的；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(五)</span> 破坏国家宗教政策，宣扬邪教和封建迷信的；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(六)</span> 散布谣言，扰乱社会秩序，破坏社会稳定的；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(七)</span>
											散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(八)</span> 侮辱或者诽谤他人，侵害他人合法权益的；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(九)</span> 含有法律、行政法规禁止的其他内容的。
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户不得以虚假信息骗取账号名称注册，或其账号头像、简介等注册信息存在违法和不良信息。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户不得冒用、关联机构或社会名人注册账号名称。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户不得以任何形式擅自转让或授权他人使用自己在本平台的用户帐号。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户有义务确保在本平台上发布的需求信息真实、准确，无误导性。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户在本平台交易中应当遵守诚实信用原则，不得以干预或操纵发布需求等不正当竞争方式扰乱网上交易秩序，不得从事与网上交易无关的不当行为。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户不应采取不正当手段（包括但不限于虚假需求、互换好评等方式）提高自身或他人信用度，或采用不正当手段恶意评价其他用户，降低其他用户信用度。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户承诺自己在使用本平台实施的所有行为遵守法律、法规、行政规章和本平台的相关规定以及各种社会公共利益或公共道德。如有违反导致任何法律后果的发生，用户将以自己的名义独立承担相应的法律责任。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户在本平台网上交易过程中如与其他用户因交易产生纠纷，可以请求本平台从中予以协调处理。用户如发现其他用户有违法或违反本协议的行为，可以向本平台举报。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									未经本平台书面允许，用户不得将本平台的任何资料以及在交易平台上所展示的任何信息作商业性利用（包括但不限于以复制、修改、翻译等形式制作衍生作品、分发或公开展示）。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户有权在同意本平台相关规则的前提下享受消费者保障服务（包括但不限于诚信保证、保证完成、保证原创、保证提供源码、保证推广效果、三个月维护、免费修改等）。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户同意接收来自本平台的信息，包括但不限于活动信息、交易信息、促销信息等。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户在增材云平台上发布项目时，不得发布国家法律、法规、行政规章规定禁止的信息、侵犯他人知识产权或其他合法权益的信息、违背社会公共利益或公共道德的信息。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户承诺自己在使用增材云平台实施的所有行为遵守法律、法规、行政规章和增材云平台的相关规定以及各种社会公共利益或公共道德。如有违反导致任何法律后果的发生，用户将以自己的名义独立承担相应的法律责任。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户在增材云平台网上交易过程中如与其他用户因交易产生纠纷，可以请求增材云平台从中予以协调处理。用户如发现其他用户有违法或违反本协议的行为，可以向增材云平台举报。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户应当自行承担因交易产生或取得的相关费用，并依法纳税。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									未经增材云平台允许，用户不得将增材云平台的任何资料以及在交易平台上所展示的任何信息作商业性利用（包括但不限于以复制、修改、翻译等形式制作衍生作品、分发或公开展示）。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户不得使用以下方式登录网站或破坏网站所提供的服务：
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span>
											以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或登录增材云平台；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											通过任何方式对本平台内部结构造成或可能造成不合理或不合比例的重大负荷的行为；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(三)</span>
											通过任何方式干扰或试图干扰平台的正常工作或平台上进行的任何活动。
										</dd>
									</dl>
								</li>
							</ol>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第五条 增材云平台的权利和义务</p>
							<ol style="padding-left: 65px;">
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台有义务在现有技术水平的基础上努力确保整个交流平台的正常运行，尽力避免服务中断或将中断时间限制在最短时间内，保证用户平台交易的顺利进行。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台有义务对用户在注册使用本平台信息中所遇到的与交易或注册有关的问题及反映的情况及时作出回复。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台有权对用户的注册资料进行审查，对存在任何问题或怀疑的注册资料，增材云平台有权发出通知询问用户并要求用户做出解释、改正。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户因在增材云平台交易与其他用户产生纠纷的，用户将纠纷告知增材云平台，或增材云平台知悉纠纷情况的，经审核后，本平台有权通过电子邮件及电话联系向纠纷双方了解纠纷情况，并将所了解的情况通过电子邮件互相通知对方；用户通过司法机关依照法定程序要求增材云平台提供相关资料，本平台将积极配合并提供有关资料。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台有权无需征得用户的同意限制用户的活动、向用户核实有关资料、发出警告通知、暂时中止、无限期中止及拒绝向该用户提供服务：
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span> 用户违反本协议或因被提及而纳入本协议的相关规则；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											存在用户或其他第三方通知增材云平台，认为某个用户或具体交易事项存在违法或不当行为，并提供相关证据，而增材云平台无法联系到该用户核证或验证该用户向增材云平台提供的任何资料；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(三)</span>
											存在用户或其他第三方通知增材云平台，认为某个用户或具体交易事项存在违法或不当行为，并提供相关证据。增材云平台以普通非专业交易者的知识水平标准对相关内容进行判别，可以明显认为这些内容或行为可能对本平台用户或本平台造成财务损失或法律责任。
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									根据国家法律、法规、行政规章规定、本协议的内容和增材云平台所掌握的事实依据，可以认定该用户存在违法或违反本协议行为以及在本平台上的其他不当行为，增材云平台有权无需征得用户的同意在增材云平台及所在网站上以网络发布形式公布该用户的违法行为，并有权随时作出删除相关信息、终止服务提供等处理。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台依据本协议及相关规则，可以冻结、使用、先行赔付、退款、处置用户缴存并冻结在本平台账户内的资金。被封号的用户如果账户中有资金，在扣除用户不正当收入后，用户可申请提现。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台有权在不通知用户的前提下，删除或采取其他限制性措施处理下列信息：包括但不限于以规避费用为目的；以炒作信用为目的；存在欺诈等恶意或虚假内容；与平台交易无关或不是以交易为目的；存在恶意竞价或其他试图扰乱正常交易秩序因素；该信息违反公共利益或可能严重损害增材云平台和其他用户合法利益的。
								</li>
							</ol>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第六条 协议终止</p>
							<ol style="padding-left: 65px;">
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									协议终止的情形
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span> 您有权通过以下任一方式终止本协议：
											<ol style="padding-left: 40px;">
												<li style="list-style: unset;list-style-position: outside;">
													在满足增材云要求的账户注销条件时您通过网站自助服务注销您的账户的；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													变更事项生效前您停止使用增材云服务并明示不愿接受变更事项的；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													您明示不愿继续使用增材云服务，且符合增材云要求的终止条件的。
												</li>
											</ol>
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											出现以下情况时，增材云可以本协议约定的有效方式通知您终止本协议：
											<ol style="padding-left: 40px;">
												<li style="list-style: unset;list-style-position: outside;">
													您的实名认证身份无效、不再合法存续或无法有效核实；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													您违反本协议约定，增材云依据违约条款终止本协议的；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													您盗用他人账户、发布违禁信息、欺诈、售假、扰乱市场秩序、采取不正当手段牟利等行为，增材云依据增材云规则对您的账户予以关闭的；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													除上述情形外，因您多次违反增材云规则相关规定且情节严重，增材云依据增材云规则对您的账户予以关闭的；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													您的账户被增材云依据本协议回收的；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													您在相关平台或领域有欺诈、发布或销售假冒伪劣/侵权产品、侵犯他人合法权益或其他严重违法违约行为的；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													增材云基于合理理由相信您的行为可能会使您、增材云及增材云用户等相关方发生严重损害或产生法律责任；
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													其它应当终止服务的情况。
												</li>
											</ol>
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									协议终止后的处理
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span>
											本协议终止后，除法律有明确规定外，增材云无义务向您或您指定的第三方披露您账户中的任何信息。
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											本协议终止后，增材云仍享有下列权利：
											<ol style="padding-left: 40px;">
												<li style="list-style: unset;list-style-position: outside;">
													在两年内保存用户在增材云平台的全部资料（包括但不限于用户信息、产品信息、交易信息等）。
												</li>
												<li style="list-style: unset;list-style-position: outside;">
													对于您过往的违约行为，增材云仍可依据本协议向您追究违约责任。
												</li>
											</ol>
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									本协议终止后，对于您在本协议存续期间产生的交易订单，增材云可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。
								</li>
							</ol>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第七条 增材云平台的责任范围</p>
							<ol style="padding-left: 65px;">
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									当用户接受该协议时，用户应当明确了解并同意∶增材云平台不能随时预见到任何技术上的问题或其他困难。该困难可能会导致数据损失或其他服务中断。增材云平台是在现有技术基础上提供的服务。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台不保证以下事项∶
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span>
											增材云平台将符合所有用户的要求；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											增材云平台不受干扰、能够及时提供、安全可靠或免于出错；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(三)</span>
											本服务使用权的取得结果是正确或可靠的。
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									是否经由增材云平台下载或取得任何资料，由用户自行考虑、并且承担风险，因下载任何资料而导致用户电脑系统的损坏或资料流失，用户应负完全责任。希望用户在使用增材云平台时，小心谨慎并注意安全。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户经由增材云平台取得的建议和资讯，无论其形式或表现，绝不构成本协议未明示规定的任何保证。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									基于以下原因而造成的利润、商誉、使用、资料损失或其它无形损失，增材云平台不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿（即使增材云平台已被告知前款赔偿的可能性）：
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span>
											云平台的使用或无法使用；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											用户的传输或资料遭到未获授权的存取或变更；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(三)</span>
											增材云平台中任何第三方之声明或行为；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(四)</span>
											增材云平台其它相关事宜。
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台只是为用户提供一个服务交易的平台，对于用户所发布项目的合法性、真实性及品质，以及用户履行交易的能力等，增材云平台一律不负任何担保责任。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台提供与其它互联网上的网站或资源的链接，用户可能会因此连接至其它运营商经营的网站，但不表示增材云平台与这些运营商有任何关系。其它运营商经营的网站均由各经营者自行负责，不属于增材云平台控制及负责范围之内。对于存在或来源于此类网站或资源的任何内容、广告、物品或其它资料，增材云平台亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、物品或服务所产生的任何损害或损失，增材云平台不负任何直接或间接的责任。
								</li>
							</ol>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第八条 知识产权</p>
							<ol style="padding-left: 65px;">
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									增材云平台及增材云平台所使用的任何相关软件、程序、内容，包括但不限于作品、图片、档案、资料、网站构架、网站版面的安排、网页设计、经由增材云平台或广告商向用户呈现的广告或资讯，均由增材云平台或其它权利人依法享有相应的知识产权，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经增材云平台或权利人明示授权，用户保证不修改、出租、出借、出售、散布增材云平台及增材云平台所使用的上述任何资料和资源，或根据上述资料和资源制作成任何种类产品。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									用户不得经由非增材云平台所提供的界面使用增材云平台。
								</li>
							</ol>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第九条 隐私权</p>
							<ol style="padding-left: 65px;">
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									信息使用：
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span>
											增材云平台不会向任何人出售或出借用户的个人或法人信息，除非事先得到用户得许可。
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											增材云平台亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人或法人信息。任何用户如从事上述活动，一经发现，增材云平台有权立即终止与该用户的服务协议，查封其账号。
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									信息披露：用户的个人或法人信息将在下述情况下部分或全部被披露：
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span>
											经用户同意，向第三方披露；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											若用户是合法的知识产权使用权人并提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(三)</span>
											根据法律的有关规定，或者行政、司法机关的要求，向第三方或者行政、司法机关披露；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(四)</span>
											若用户出现违反中国有关法律或者网站规定的情况，需要向第三方披露；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(五)</span>
											为提供你所要求的产品和服务，而必须和第三方分享用户的个人或法人信息；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(六)</span>
											其它增材云平台根据法律或者网站规定认为合适的披露。
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									信息安全：
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span>
											在使用增材云平台服务进行平台交易时，请用户妥善保护自己的个人或法人信息，仅在必要的情形下向他人提供；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											如果用户发现自己的个人或法人信息泄密，尤其是账户及密码发生泄露，请用户立即联络增材云平台客服，以便我们采取相应措施。
										</dd>
									</dl>
								</li>
							</ol>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;"> 第十条 不可抗力</p>
							<p style="text-indent: 30px">
								因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本合同所称之不可抗力意指不能预见、不能避免并不能克服的客观情况，包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、法定疾病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等客观情况。
							</p>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第十一条 保密</p>
							<p style="text-indent: 30px">
								双方保证在对讨论、签订、执行本协议中所获悉的属于对方的且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。未经该资料和文件的原提供方同意，另一方不得向第三方泄露该商业秘密的全部或者部分内容。但法律、法规、行政规章另有规定或者双方另有约定的除外。
							</p>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第十二条 争议解决方式</p>
							<ol style="padding-left: 65px;">
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									您可通过增材云所支持的交易方式与其他用户达成交易，并遵守相应交易与支付规则。您理解并同意，增材云仅作为用户物色交易对象，就商品和服务的交易进行协商，以及获取各类与贸易相关的服务的地点，增材云不会参与用户间的交易，亦不会涉及用户间因交易而产生的法律关系及法律纠纷。
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									您在增材云交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：
									<dl style="padding-left: 30px;">
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(一)</span>
											与争议相对方自主协商；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(二)</span>
											使用增材云提供的争议调处服务；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(三)</span>
											向有关行政部门投诉；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(四)</span>
											根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；
										</dd>
										<dd style="padding-left:30px;position: relative;"><span
												style="position: absolute;left: 0;">(五)</span>
											向人民法院提起诉讼。
										</dd>
									</dl>
								</li>
								<li style="list-style: simp-chinese-informal;list-style-position: outside;">
									如您依据增材云规则使用增材云的争议调处服务，则表示您认可并愿意履行增材云的客服作为独立的第三方根据其所了解到的争议事实并依据增材云规则所作出的调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方、执行相应的保证金赔付等）。在增材云调处决定作出前，您可选择上述其他争议处理途径解决争议以中止增材云的争议调处服务。如您对调处决定不满意，您仍有权采取其他争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您仍应先履行调处决定。
								</li>
							</ol>
							<p style="font-weight:bold;font-size: 15px;padding: 3px 0;">第十三条</p>
							<p style="text-indent: 30px">增材云平台对本服务协议包括基于本服务协议制定的各项规则拥有最终解释权。</p>
						</div>
						<span slot="footer" class="dialog-footer">
							<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
							<el-button type="primary" @click="dialogVisible = false">同意服务条款</el-button>
						</span>
					</el-dialog>
					<div class="registered_button" @click="getRegisteredMess">
						<el-button type="primary">注册</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	// import Verify from "vue2-verify";
	import Vcode from "vue-puzzle-vcode";
	import {
		getRegistered,
		getSecurityCode,
		getSmscode,
		getNewcurrent,
		getRegisteredOr,
		existsUserName
	} from "../../utils/interface";

	export default {
		//  注册
		name: "registered",
		components: {
			Vcode
		},
		data() {
			return {
				parkHeight: "",
				validCode: "",
				inputUsername: "",
				inputIphone: "",
				iphoneRepeatMess: "",
				iphoneRepeat: false,
				inputPassword: "",
				inputPasswordAg: "",
				passwordAgTrue: false,
				inputMessage: "",
				checked: false,
				validation: false,
				validationSuc: "",
				imgUrls: 'https://picsum.photos/200/300',
				vcodes: false,
				canClick: true,
				timeClock: 60,
				dialogVisible: false,
				cryptographicMessage: '',
				cryptographicFlag: true,
				clock: null,
			};
		},
		created() {
			this.parkHeight = document.documentElement.clientHeight + "px";
			this.vuexAllPark(false);
		},
		watch: {},
		computed: {
			...mapState({
				isTokenDoor: "isTokenDoor",
			}),
		},
		mounted() {
			window.scrollTo(0, 0);
			if (this.inputIphone) {
				this.getinputIphone()
			}
			this.cryptographic()
		},
		methods: {
			...mapMutations(["vuexAllPark", "isLoginVuex"]),
			// 顶部跳转
			getRegisteredLogin(num) {
				if (num == 1) {
					this.$router.push("/");
				} else if (num === 2) {
					this.$router.push("/helpCenter");
				}
			},
			getLogin() {
				this.$router.push("/login");
			},
			// 验证初始密码和再次输入密码是否一致
			passwordAgChange() {
				if (this.inputPassword != this.inputPasswordAg) {
					this.passwordAgTrue = true;
				} else {
					this.passwordAgTrue = false;
				}
			},
			getinputIphone() {
				const reg = /^[1][3-9]\d{9}$/;
				if (!reg.test(this.inputIphone)) {
					this.iphoneRepeatMess = '请正确填写手机号';
					return;
				}
				if (this.inputIphone) {
					//  校验是否注册过
					let paramsOr = {
						username: this.inputIphone,
					};
					existsUserName(paramsOr)
						.then((res) => {
							this.iphoneRepeat = res.success;
							if (this.iphoneRepeat == true) {
								this.iphoneRepeatMess = '手机号已注册，请直接登录';
							} else {
								this.iphoneRepeatMess = "";
							}
						})
						.catch((err) => {
							console.log(err);
						});
				} else {
					this.iphoneRepeatMess = '';
				}
			},
			// 拼图验证码
			getValidation() {
				this.getinputIphone();
				if (this.iphoneRepeatMess === "") {
					this.validation = true;
				} else {
					this.$alert("您的手机号码填写有误", "提示", {
						confirmButtonText: "确定",
					});
				}

			},
			// 用户的验证回调
			onValidation(status, msg) {
				if (status == "yes") {
					// this.vcodes = true;
					let params = {
						account: this.inputIphone
					};
					getSecurityCode(params)
						.then((res) => {
							this.vcodes = true;
							this.validCode = res.data;
						})
						.catch((err) => {
							console.log(err);
						});
				} else if (status == "no") {
					this.vcodes = false;
				}
				this.validation = false; // 通过验证后，需要手动隐藏模态框
				//可以在此加上axios或其他代码
			},
			// 用户点击遮罩层，应该关闭模态框
			onClose() {
				this.validation = false;
				this.$message({
					message: "取消验证！",
					type: "warning",
				});
			},
			// 点击注册信息
			getRegisteredMess() {
				window.clearInterval(this.clock);
				this.clock = null
				this.timeClock = 60
				this.canClick = true;
				let params = {
					name: this.inputUsername,
					mobile: this.inputIphone,
					password: this.inputPassword,
					validCode: this.validCode,
					smsCode: this.inputMessage,
				};
				// console.log("注册", res.success);
				const reg = /^[1][3-9]\d{9}$/;
				if (
					this.inputUsername == "" ||
					this.inputIphone == "" ||
					!reg.test(this.inputIphone) ||
					this.inputPassword == "" ||
					this.inputPasswordAg == "" ||
					this.inputMessage == "" ||
					this.checked == false ||
					this.vcodes == false ||
					this.passwordAgTrue == true ||
					this.iphoneRepeat == true ||
					!this.cryptographicFlag
					// res.success == false
				) {
					var regu = "^[ ]+$";
					var re = new RegExp(regu);
					if (this.inputUsername == "" || re.test(this.inputUsername)) {
						this.$alert("您的昵称不能为空", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.inputIphone == "") {
						this.$alert("您的手机号码不能为空", "提示", {
							confirmButtonText: "确定",
						});
					} else if (!reg.test(this.inputIphone)) {
						this.$alert("请输入正确的手机号码", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.inputPassword == "") {
						this.$alert("您的密码不能为空", "提示", {
							confirmButtonText: "确定",
						});
					} else if (!this.cryptographicFlag) {
						this.$alert("密码校验不通过，请重新输入密码", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.inputPasswordAg == "") {
						this.$alert("再次输入密码不能为空", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.passwordAgTrue == true) {
						this.$alert("您输入的两次密码不相符，请重新输入", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.inputMessage == "") {
						this.$alert("您的短信验证码不能为空", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.checked == false) {
						this.$alert("请阅读《隐私协议》并同意", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.vcodes == false) {
						this.$alert("请进行安全验证", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.iphoneRepeat == true) {
						this.$alert(this.iphoneRepeatMess, "提示", {
							confirmButtonText: "确定",
						});
					}
				} else {
					getRegistered(params)
						.then((res) => {
							if (res.success == true) {
								// console.log('res.data.token.access_token',res );
								this.$cookies.remove("api_access_token");
								this.$cookies.set(
									"api_access_token",
									res.data.token.access_token
								);
								this.$cookies.set("api_token_new", res.data.token.access_token);
								// console.log('this.$cookies.get',this.$cookies.get("api_access_token") );
								this.isLoginVuex(true);
								this.$router.replace("/regSuccess");

								// this.$alert("注册成功", "提示", {
								//     confirmButtonText: "确定",
								//     callback: () => {
								//         // this.$router.go(-1);
								//     },
								// });

							} else {
								this.$alert(res.message, "提示", {
									confirmButtonText: "确定",
									callback: (action) => {
										// this.inputUsername = "";
										// this.inputIphone = "";
										// this.inputPassword = "";
										// this.inputPasswordAg = "";
										this.inputMessage = "";
										this.checked = false;
										this.vcodes = false;
										this.canClick = true;
										this.timeClock = 60
									},
								});
							}
							this.timeClock = 60

						})
						.catch((err) => {
							console.log(err);
						});
				}
			},
			// 倒计时60s
			getCountdown() {
				if (this.vcodes == true && this.iphoneRepeatMess == "" && this.cryptographicFlag) {
					let params = {
						mobile: this.inputIphone,
						validCode: this.validCode,
					};
					getSmscode(params)
						.then((res) => {
							if (res.success == true) {
								this.canClick = false;
								if (this.clock != null) return
								this.clock = window.setInterval(() => {
									if (this.timeClock > 0) {
										this.timeClock--;
									} else if (this.timeClock <= 0) {
										window.clearInterval(this.clock);
										this.clock = null
										this.timeClock = 60
										this.canClick = true;
									}
								}, 1000);
							} else {
								this.$alert(res.message, "提示", {
									confirmButtonText: "确定",
								});
							}
						})
						.catch((err) => {
							console.log(err);
						});
				} else {
					if (this.vcodes == false) {
						this.$alert("安全验证失败，请重新验证", "提示", {
							confirmButtonText: "确定",
						});
					} else if (this.iphoneRepeatMess != "") {
						this.$alert("手机号已注册，请直接登录", "提示", {
							confirmButtonText: "确定",
						});
					} else if (!this.cryptographicFlag) {
						this.$alert("密码校验不通过，请重新输入密码", "提示", {
							confirmButtonText: "确定",
						});
					}
				}
			},
			// 协议
			getAgreement() {
				this.dialogVisible = true;
			},
			// 密码校验
			cryptographic() {
				if (this.inputPassword) {
					if (this.inputPassword.length < 8) {
						this.cryptographicMessage = '密码长度不小于8位'
						this.cryptographicFlag = false
					} else if (!this.validate.isUserPassword(this.inputPassword)) {
						this.cryptographicMessage = '数字,字母,字符至少包含两种,不能包含中文和空格'
						this.cryptographicFlag = false
					} else if (this.inputPassword.length >= 30) {
						this.cryptographicMessage = '密码长度不大于30位'
						this.cryptographicFlag = false
					} else {
						this.cryptographicMessage = ''
						this.cryptographicFlag = true
					}
				} else {
					this.cryptographicMessage = ''
					this.cryptographicFlag = true
				}
			}
		},
	};
</script>

<style scoped lang="less">
	.blue {
		color: #1181ff;
	}

	.red {
		color: #d60000;
	}

	.registered {
		width: 1200px;
		margin: 0 auto;
		background: #fff;
		border-radius: 10px;

		.registeredTop {
			border-bottom: 1px solid #f9f9f9;
			padding: 18px 30px 18px 44px;
			align-items: center;
			justify-content: space-between;

			// margin: 40px 0;
			span {
				cursor: pointer;
			}
		}

		.registered_input_box {
			display: flex;
			justify-content: center;

			.registered_input {
				padding-bottom: 50px;
				width: 50%;
				padding-top: 30px;

				/deep/ .el-input {
					// width: 50%;
					// margin-bottom: 25px;
				}

				/deep/ .el-input__inner {
					background: #f9f9f9;
					color: #777;
					border: none;
					height: 52px;
				}

				.passAg {
					align-items: center;

					p {
						font-size: 14px;
						margin-left: 10px;
						margin-bottom: 25px;
						flex-shrink: 0;
					}
				}

				.registered_input_message {
					position: relative;

					/deep/ .el-input {}

					.registered_input_messageP {
						position: absolute;
						right: 30px;
						top: 15px;
						cursor: pointer;
					}
				}

				.registered_message {
					margin-top: 20px;
					font-size: 14px;
					cursor: default;

					span {
						cursor: pointer;
					}
				}

				.registered_validation2 {
					background: #3aead336;
					height: 52px;
					margin-bottom: 25px;
					align-items: center;
					color: #777;
					cursor: default;
					justify-content: center;
					color: #6dcaaa;
					border: 1px solid #6dcaaa;

					i {
						font-size: 20px;
						font-weight: bold;
						margin-right: 10px;
					}
				}

				.registered_validation {
					background: #f9f9f9;
					height: 52px;
					margin-bottom: 25px;
					align-items: center;
					color: #777;
					cursor: pointer;

					img {
						margin: 0 13px;
					}

					.validationVerify {
						z-index: 99;
					}
				}
			}

			.registered_agree {
				margin-top: 10px;
			}

			.registered_button {
				width: 100%;
				margin-top: 40px;

				/deep/ .el-button {
					width: 100%;
				}
			}
		}
	}

	.tittle {
		position: fixed;
		background: #fff;
		box-shadow: 0 -1px 0 #f0f0f0 inset;
		width: 100%;
		height: 50px;
		z-index: 9999;

		.titleTop {
			// width: 1200px;
			width: 100%;
			height: 100%;
			padding: 0 50px 0 30px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.logo {
			align-items: center;
			justify-content: center;
			display: flex;

			// margin: 19px 42px 0 38px;
			// align-items: center;
			// justify-content: center;
			// display: flex;
			// flex: 1;
			img {
				height: 33px;
				// margin: 8px 0 0 0;
				padding: 0;
			}
		}
	}

	.login {
		justify-content: center;
		align-items: center;

		// flex: 1;
		.lh90 {
			cursor: pointer;
			font-size: 13px;
		}

		.lh90:nth-last-child(1) {
			margin-left: 20px;
		}
	}

	/deep/ .el-dialog {
		height: 600px;
		// max-height: 50%;
		// overflow: hidden;
	}

	/deep/ .el-dialog--center .el-dialog__body {
		overflow-y: scroll;
		height: 78%;
		// min-height: 54%;
		margin: 10px 20px;
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/registeredIndex.vue